import { create } from "zustand";
import { generateClient, type GraphQLResult } from "aws-amplify/api";
import { addUserRestaurants as addUserRestaurantsMutation } from "@/graphql/mutations";
import { getUserRestaurants } from "./userRestaurantsState";
import { triggerEvent } from "@/lib/utils";
import { setActionTriggerNeedNetwork } from "./restrictedFeatureState";
import type { GraphQLError } from "graphql";

const client = generateClient();

type UserAddRestaurantsState = {
  data: boolean | null;
  isLoading: boolean;
  isFetching: boolean;
  error: GraphQLError[] | null;
};

export const userAddRestaurantsState = create<UserAddRestaurantsState>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const getAddRestaurantsIsloading = () =>
  userAddRestaurantsState.setState(() => ({
    isLoading: true,
    isFetching: false,
    data: null,
    error: null,
  }));
export const getAddRestaurantsIsError = (error: GraphQLError[]) =>
  userAddRestaurantsState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
    isFetching: false,
  }));
export const getAddRestaurantsIsSuccess = (queryResult: boolean) =>
  userAddRestaurantsState.setState(() => ({
    data: queryResult,
    isLoading: false,
    error: null,
    isFetching: false,
  }));

export const resetUserRestaurantsState = () =>
  userAddRestaurantsState.setState(() =>
    userAddRestaurantsState.getInitialState(),
  );

export const addUserRestaurants = async (restaurantsId: string[]) => {
  getAddRestaurantsIsloading();

  try {
    await client.graphql({
      query: addUserRestaurantsMutation,
      variables: {
        restaurantIds: restaurantsId,
      },
    });

    getAddRestaurantsIsSuccess(true);
    getUserRestaurants();

    restaurantsId.forEach((restaurantId) => {
      triggerEvent("Store Added", {
        Store_Id_Added: restaurantId,
      });
    });
  } catch (e) {
    const graphQl = e as GraphQLResult<boolean>;
    const restaurantsError = graphQl.errors as GraphQLError[];

    getAddRestaurantsIsError(restaurantsError);
    if (
      restaurantsError &&
      restaurantsError[0] &&
      restaurantsError[0].message === "User restaurant quota exceeded"
    ) {
      setActionTriggerNeedNetwork(true);
    }
  }
};
